@if (impersonation) {
  <div class="impersonation-banner">
    {{
      "impersonation.banner"
        | transloco
          : {
              admin: impersonation.impersonatorUsername,
              user: impersonation.username,
              minutes: (minutesLeft$ | async)
            }
    }}
    <button type="button" class="impersonation-exit" (click)="exit()">
      {{ "impersonation.exit" | transloco }}
    </button>
  </div>
}
